import React from "react";
import { render } from "react-dom";
import { HashRouter } from "react-router-dom";
import Analytics from "react-router-ga";
import App from "./App";

// https://medium.com/@pshrmn/a-simple-react-router-v4-tutorial-7f23ff27adf

render(
  <HashRouter>
    <Analytics id="UA-46658795-1">
      <App />
    </Analytics>
  </HashRouter>,
  document.getElementById("root")
);



// WEBPACK FOOTER //
// ./src/index.js